/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DiaboloPhaseInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class DiaboloPhaseApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'DiaboloPhases');
  }

  find(params?): Observable<DiaboloPhaseInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<DiaboloPhaseInterface[]>(path, httpParams);
  }
}
